/**
 * THE WING TAB ROW — one treatment for Grow and Studio (PROHUB-43; Peter, 2026-08-29:
 * "Top menu is not looking balanced when the sub sections opens").
 *
 * What he was seeing: Studio's seven pills at the old size wrapped into a ragged
 * three-line pile with "Support" orphaned alone on the last row. Grow's three fit one
 * line, which is why it never showed there. The compact size packs seven into two even
 * rows (4/3, no orphan) on a phone — previewed live on the real screen before shipping.
 *
 * ONE COMPONENT, not two copies: the two wings wear the same row so the treatment
 * cannot drift apart (the two-derivations disease, applied to styling). Both pages
 * hand in their items and keep their own routing.
 */
export function WingTabs({ tabs, active, onPick, testId }: {
  tabs: ReadonlyArray<readonly [string, string]>;
  active: string;
  onPick: (key: string) => void;
  testId?: string;
}) {
  return (
    <div className="flex flex-wrap gap-1.5" data-wing-tabs={testId ?? true}>
      {tabs.map(([k, label]) => (
        <button key={k} type="button" aria-pressed={active === k}
          className={`rounded-full px-3 py-1.5 text-xs font-bold ring-1 transition-all ${
            active === k ? 'bg-image-pink text-white ring-image-pink'
                         : 'bg-white text-image-charcoal ring-image-border hover:ring-image-pink'}`}
          onClick={() => onPick(k)}>
          {label}
        </button>
      ))}
    </div>
  );
}
